import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { CoreModule } from 'src/app/components/core/core.module';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { NgSelectModule } from '@ng-select/ng-select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { NgbAlert, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CultivoService } from './cultivo.service';
import { CultivoRoutingModule } from './cultivo-routing.module';
import { CultivoListComponent } from './cultivo-list/cultivo-list.component';
import { CultivoWrapperEditComponent } from './cultivo-wrapper-edit/cultivo-wrapper-edit.component';
import { CultivoWrapperComponent } from './cultivo-wrapper/cultivo-wrapper.component';
import { CultivoEditComponent } from './cultivo-edit/cultivo-edit.component';
import { EspeciesModule } from '../../_mantenimiento/especies/especies.module';
import { CultivoSuperficieComponent } from './cultivo-superficie/cultivo-superficie.component';
import { CalendarModule } from 'primeng/calendar';
import { CultivoDesautorizadoCamService } from './cultivo-desautorizado-cam.service';

@NgModule({
    declarations: [CultivoWrapperEditComponent, CultivoWrapperComponent, CultivoListComponent, CultivoEditComponent, CultivoSuperficieComponent],
    imports: [
        ProgressSpinnerModule,
        NgbModule,
        NgbAlert,
        SelectButtonModule,
        NgSelectModule,
        TableModule,
        PaginatorModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CultivoRoutingModule,
        CoreModule,
        CalendarModule,
        EspeciesModule, // Incorporamos el componente Variedad-Buscador,
    ],
    providers: [ExceptionManager, CultivoService, CultivoDesautorizadoCamService],
    exports: [CultivoWrapperComponent],
})
export class CultivoModule {}
